module.exports = __webpack_public_path__ + "img/67.689c208e.png";